let timelines = $('.timeline');

if(timelines.length) {

    timelines.each(function () {

        console.log('Timeline Found');

        timelineHeaders = $(this).find('.timeline-header');

        timelineHeaders.on('click', function (e) {
            if(!$(this).hasClass('has-image')) return true;

            let timelineItem = $(this).parent();
            timelineItem.toggleClass('opened');
            timelineHeaders.not($(this)).parent().removeClass('opened');
            timelineHeaders.not($(this)).parent().find('.timeline-image-container').slideUp();
            timelineItem.find('.timeline-image-container').slideToggle();
        });

    });

}
